/* Amanda's Gifts guide pages (sections/ag-guide.liquid):
   1) product card option selects -> variant id, price and button state (the form is Horizon's
      product-form-component, so Add to cart and the cart drawer work as on product pages);
   2) "Read the full card" toggle (full text is always in the HTML, only hidden by CSS);
   3) FAQ accordion buttons (aria-expanded). */
(() => {
  // /pages/<handle> on the live page; ?view=<handle> on the template preview
  function guideHandle() {
    const m = location.pathname.match(/\/pages\/([a-z0-9-]+)/);
    const view = new URLSearchParams(location.search).get('view');
    return (view && /^[a-z0-9-]+$/.test(view) ? view : m && m[1]) || '';
  }
  // Cart attribute _guide = the first guide this visitor read (set on page load, so an order placed
  // later from a product page still carries it); a different later guide goes to _guide_last.
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  async function tagCart(guide) {
    if (!guide) return;
    try {
      const cart = await (await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      const a = (cart && cart.attributes) || {};
      const attrs = !a._guide ? { _guide: guide } : (a._guide !== guide && a._guide_last !== guide ? { _guide_last: guide } : null);
      if (!attrs) return;
      await fetch(root() + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, keepalive: true,
        body: JSON.stringify({ attributes: attrs }),
      });
    } catch (e) { /* attribution must never break the page */ }
  }
  function initCard(card) {
    const json = card.querySelector('[data-ag-gp-variants]');
    const input = card.querySelector('input[name="id"]');
    // order attribution (owner 2026-10-25): hidden line property + cart attribute _guide = page handle.
    // Underscore keys are hidden by Horizon's cart drawer/cart page and at checkout.
    const guide = guideHandle();
    const form = input && input.form;
    if (guide && form && !form.querySelector('input[name="properties[_guide]"]')) {
      const prop = document.createElement('input');
      prop.type = 'hidden'; prop.name = 'properties[_guide]'; prop.value = guide;
      form.appendChild(prop);
      form.addEventListener('submit', () => tagCart(guide));
    }
    const selects = [...card.querySelectorAll('[data-ag-gp-opt]')];
    if (!json || !input) return;
    let variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    const price = card.querySelector('[data-ag-gp-price]');
    const from = card.querySelector('[data-ag-gp-from]');
    const btn = card.querySelector('button[name="add"]');
    const label = btn && [...btn.childNodes].find((n) => n.nodeType === 3 && n.textContent.trim());
    const addText = label ? label.textContent.trim() : '';
    const soldOut = (window.Theme && Theme.translations && Theme.translations.sold_out) || 'Sold out';
    const update = () => {
      const chosen = selects.map((s) => s.value);
      const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
      if (v) input.value = v.id;
      if (price && v) price.textContent = v.price;
      // variant image (falls back to the product image in the JSON when the variant has none)
      const img = card.querySelector('.ag-gp__img');
      if (img && v && v.img && img.dataset.agSrc !== v.img) {
        img.dataset.agSrc = v.img;
        img.removeAttribute('loading');
        if (v.srcset) img.srcset = v.srcset;
        img.src = v.img;
        if (v.alt) img.alt = v.alt;
      }
      if (from) from.hidden = true;
      if (btn) {
        const ok = !!(v && v.available);
        btn.disabled = !ok;
        if (label) label.textContent = ok ? addText : soldOut;
      }
    };
    selects.forEach((s) => s.addEventListener('change', update));
    // Horizon marks the button data-added="true" after a successful add: show "Added to cart" for 2 s
    if (btn && label) {
      let timer;
      new MutationObserver(() => {
        if (btn.dataset.added !== 'true') return;
        label.textContent = 'Added to cart';
        clearTimeout(timer);
        timer = setTimeout(() => { if (!btn.disabled) label.textContent = addText; }, 2000);
      }).observe(btn, { attributes: true, attributeFilter: ['data-added'] });
    }
  }
  function initToggle(btn) {
    const text = document.getElementById(btn.getAttribute('aria-controls'));
    if (!text) return;
    const first = text.querySelector(':scope > p');
    if (first && /[.!?,]$/.test(first.textContent.trim())) first.classList.add('ag-noell');
    if (text.querySelectorAll(":scope > p").length < 2 && (!first || first.scrollWidth <= first.clientWidth)) { text.classList.remove('is-collapsed'); btn.hidden = true; return; }
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', String(open));
      text.classList.toggle('is-collapsed', !open);
      btn.textContent = open ? 'Show less' : 'Read the full card';
    });
  }
  function initFaq(btn) {
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    const icon = btn.querySelector('.ag-g__faq-icon');
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', String(open));
      if (panel) panel.hidden = !open;
      if (icon) icon.textContent = open ? '−' : '+';
    });
  }
  const once = (el, fn) => { if (el.dataset.agReady) return; el.dataset.agReady = '1'; fn(el); };
  const run = () => {
    if (document.querySelector('.ag-g') && !window.__agGuideTagged) { window.__agGuideTagged = true; tagCart(guideHandle()); }
    document.querySelectorAll('[data-ag-gp]').forEach((el) => once(el, initCard));
    document.querySelectorAll('[data-ag-card-toggle]').forEach((el) => once(el, initToggle));
    document.querySelectorAll('[data-ag-faq]').forEach((el) => once(el, initFaq));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
